export const linkList = [
  {
    link: "/",
    name: "PROJECTS",
  },
  {
    link: "/aboutme",
    name: "ABOUT ME",
  },
];
